<template>
    <svg
        :width="width"
        :height="height"
        :fill="iconColor"
        :viewBox="getViewBox"
        :aria-labelledby="iconName"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
    >
        <title :id="iconName" lang="en">{{ iconName }} icon</title>
        <slot />
    </svg>
</template>

<script>
export default {
    name: 'BaseIcon',

    props: {
        iconName: {
            type: String,
            default: 'box',
        },
        customSize: {
            type: Boolean,
            default: false,
        },
        width: {
            type: [Number, String],
            default: 32,
        },
        height: {
            type: [Number, String],
            default: 32,
        },
        iconColor: {
            type: String,
            default: '#666666',
        },
    },

    computed: {
        getViewBox() {
            if (this.customSize) return `0 0 ${this.width} ${this.height}`;
            return '0 0 32 32';
        },
    },
};
</script>

<style scoped>
svg {
    display: inline-block;
    vertical-align: baseline;
}
</style>
